import React, { useEffect } from "react";
import briefcaseIcon from "../src/images/briefcase.svg";
import phoneIcon from "../src/images/phone-icon.svg";
import emailIcon from "../src/images/email-icon.svg";
import birthdayIcon from "../src/images/birthday-icon.svg";
import { useLocation, useParams } from "react-router-dom";
import { useState } from "react";
import placeholder from "./images/image-placeholder.svg";
import userPlaceholder from "./images/user-placeholder.svg";
import appIcon from "./images/appIcon.png";
import { isAndroid, isIOS, BrowserTypes, OsTypes, osName, browserName } from 'react-device-detect';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function Profile() {
  // const param = useSearchParams();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const user_id = queryParams.get("user_id");
  const NFC = queryParams.get("Nfc");
  const { code } = useParams();

  let iosAppLink = "";
  let androidAppLink = "";

  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [device, setDevice] = useState(null) // 1 : chrome, 2 : safari, 3 : android, 4 : ios
  const [isMounted, setIsMounted] = useState(false);
  const [isProfileExist, setIsProfileExist] = useState(true);
  const [isExist, setIsExist] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    setIsMounted(true);
    return () => setIsMounted(false);
  }, []);

  // Fetches user profile data from the API based on the provided user_id and code
  const getUserData = async () => {
    try {
      setLoading(true);
      const response = await fetch(
        `${process.env.REACT_APP_API_KEY}profile/${code}?user_id=${user_id}`,
        {
          method: "GET",
        }
      );
      const datas = await response.json();
      if (datas.code == 1) {
        setLoading(false);
        setIsProfileExist(true);
        setIsExist(true);
        setData(datas.data);
      } else {
        setIsProfileExist(false);
        setIsExist(false);
        setErrorMessage(datas.message)
        setLoading(false);
      }
    } catch (error) {
      setIsProfileExist(false);
      setIsExist(false);
      setErrorMessage(error.message || error.response.message)
      setLoading(false);
    }
  };

  useEffect(() => {
    if (isExist) {
      if (isAndroid) {
        setDevice(3);
        openAppOrRedirect(3);
      }
      else if (isIOS) {
        setDevice(4);
        openAppOrRedirect(4);
      }
      else if (osName == OsTypes.Windows || browserName == BrowserTypes.Chrome) setDevice(1);
      else if (osName == OsTypes.MAC_OS || browserName == BrowserTypes.Safari) setDevice(2);
    }
    if (user_id && user_id.length > 0 && isMounted) {
      getUserData();
    }
  }, [isMounted, isExist]);

  // Handles deep linking to the native app or redirects to app store if app is not installed
  const openAppOrRedirect = (deviceType) => {
    if (device == 3 || deviceType == 3) {
      const fallbackUrl = `https://play.google.com/store/apps/details?id=com.onlyfounder`;
      if (NFC && NFC == 1) {
        androidAppLink = `intent://profile/${code}?user_id=${user_id}&Nfc=${NFC}#Intent;scheme=${process.env.REACT_APP_WEB_KEY};package=com.onlyfounder;S.browser_fallback_url=${encodeURIComponent(fallbackUrl)};end`;
      }
      else {
        androidAppLink = `intent://profile/${code}?user_id=${user_id}#Intent;scheme=${process.env.REACT_APP_WEB_KEY};package=com.onlyfounder;S.browser_fallback_url=${encodeURIComponent(fallbackUrl)};end`;
      }
      window.location = androidAppLink;
      setTimeout(function () {
        if (document.hasFocus()) {
          window.location = `https://play.google.com/store/apps/details?id=com.onlyfounder`;
        }
      }, 3000);
    }
    else if (device == 4 || deviceType == 4) {
      if (NFC && NFC == 1) {
        iosAppLink = `onlyfounders://profile/${code}?user_id=${user_id}&Nfc=${NFC}`;
      } else {
        iosAppLink = `onlyfounders://profile/${code}?user_id=${user_id}`;
      }
      window.location.href = iosAppLink;
      setTimeout(function () {
        if (document.hasFocus()) {
          window.location = `https://apps.apple.com/us/app/onlyfounders-find-cofounders/id6451452254`;
        }
      }, 2000);
    }
  }

  // Opens the selected social media app link in a new tab
  const handleClick = (app) => {
    let url;
    switch (app.app_name) {
      case 'WhatsApp':
        url = `https://wa.me/${app.app_link}`;
        break;
      default:
        url = app.app_link;
    }
    window.open(url, '_blank');
  };

  if (code && user_id && user_id.length > 0 && user_id.length > 0 && isProfileExist) {
    return (
      <div className="pb-6 md:pb-10">
        {!data && loading ? (
          <div className="loaderCenter">
            <span className="loader"></span>
          </div>
        ) : (
          <div className="container mx-auto px-4">
            {(device == 3 || device == 4) && <div className="flex lg:justify-end justify-center lg:mb-0 mb-2 lg:items-end items-center mx-30 ">
              <div className="lg:w-1/2 w-0" />
              <div className="lg:w-1/3 w-full shadow-lg px-2 rounded-b-lg bg-white flex justify-between items-center h-16">
                <div className="flex items-center">
                  <img
                    src={appIcon}
                    alt="app"
                    className="h-8 w-8 mr-2"
                  />
                  <div>
                    <p className="font-bold">Open OnlyFounders App</p>
                    <p className="text-xs text-slate-500 pt-[2px]">Find CoFounders & Get a Free Digital Business Card</p>
                  </div>
                </div>
                <button onClick={openAppOrRedirect} className="bg-[#36302f] rounded-full text-lg px-4 py-1 text-white">
                  <p className="font-bold text-center leading-normal">
                    Open
                  </p>
                </button>
              </div>
            </div>}
            <div className="mb-3 md:my-4 xl:my-10 pb-[50px] md:pb-[100px] relative -mx-4 md:mx-0">
              <div className="overflow-hidden md:rounded-2xl w-full h-[180px] md:h-[400px] flex justify-center items-center md:border-[8px] shadow-lg border-white bg-[#E6E9EC]">
                {data?.cover_image && data?.cover_image.length > 0 ? (
                  <img
                    src={data?.cover_image}
                    alt=""
                    className="md:rounded-2xl w-full h-[180px] md:h-[400px] object-cover md:border-[8px] shadow-lg border-white bg-[#E6E9EC]"
                  />
                ) : (
                  <img
                    src={placeholder}
                    alt=""
                    className="rounded-2xl max-w-full max-h-full object-cover"
                  />
                )}
              </div>
              {data?.profile_pic && data?.profile_pic.length > 0 ? (
                <img
                  src={data?.profile_pic}
                  alt=""
                  className="rounded-full w-[100px] md:w-[200px] aspect-square object-cover border-4 md:border-8 border-solid border-white absolute bottom-0 left-4 md:left-[25px]"
                />
              ) : (
                <img
                  src={userPlaceholder}
                  alt=""
                  className="rounded-full w-[100px] md:w-[200px] aspect-square object-cover border-4 md:border-8 border-solid border-white absolute bottom-0 left-4 md:left-[25px]"
                />
              )}
            </div>
            <div className="shine-card mb-5 md:mb-10">
              <ul className="mb-4 flex flex-wrap items-center gap-4">
                {data?.appLink.map((appData, i) => {
                  return (
                    <button key={i} onClick={() => handleClick(appData)}>
                      <li key={i}>
                        <div
                          className="w-14 aspect-square rounded-full border border-[#E3DEDE] inline-flex items-center justify-center"
                        >
                          <img
                            src={appData.user_app_icon}
                            alt=""
                            className="w-7"
                          />
                        </div>
                      </li>
                    </button>
                  );
                })}
              </ul>
              <div className="text-xl md:text-2xl font-bold text-left">
                <span className="font-serif">{data?.name ? data?.name.split(' ')[0] : "--"}</span>{" "}
                <span className="font-serif-italic">{data?.name ? data?.name.split(' ').slice(1).join(' ') : ""}</span>
              </div>
              <p className="my-3 text-inherit md:text-lg leading-tight text-left overflow-hidden font-serif">
                {data?.bio ? data?.bio : "--"}
              </p>
              <ul>
                <li className="flex items-center gap-3 md:gap-4 border-b border-[#EEEBEB] pb-3 md:pb-4 mb-3 md:mb-4">
                  <label className="font-semibold text-inherit md:text-lg font-serif">
                    {data?.country_flag ? data?.country_flag : "--"}
                  </label>
                  <label className="font-semibold text-inherit md:text-lg font-serif-italic">
                    {data?.city_name.concat(
                      data?.city_name ? " , " : "",
                      data?.state_name,
                      " , ",
                      data?.country_name
                    )}
                  </label>
                </li>
                <li className="flex items-center gap-3 md:gap-4 border-b border-[#EEEBEB] pb-3 md:pb-4 mb-3 md:mb-4">
                  <img src={phoneIcon} alt="" className="w-7 md:w-9" />
                  <label className="font-semibold text-inherit md:text-lg font-serif">
                    {data?.phone_number && data?.phone_number !== "" ? data?.country_code.concat(" ", data?.phone_number) : "--"}
                  </label>
                </li>
                <li className="flex items-center gap-3 md:gap-4 border-b border-[#EEEBEB] pb-3 md:pb-4 mb-3 md:mb-4">
                  <img src={emailIcon} alt="" className="w-7 md:w-9" />
                  <label className="font-semibold text-inherit md:text-lg font-serif-italic">
                    {data?.email ? data?.email : "--"}
                  </label>
                </li>
                <li className="flex items-center gap-3 md:gap-4">
                  <img src={birthdayIcon} alt="" className="w-7 md:w-9" />
                  <label className="font-semibold text-inherit md:text-lg font-serif">
                    {data?.dob ? data?.dob : "--"}
                  </label>
                </li>
              </ul>
            </div>
            <div className="shine-card mb-5 md:mb-10">
              <h3 className="text-xl md:text-2xl text-[#363030] font-bold mb-1">
                <span className="font-serif">What I&apos;m</span>{" "}<span className="font-serif-italic">Building/Seeking</span>
              </h3>
              <div className="flex">
                <label className="text-lg md:text-xl font-serif">
                  {data?.vision ? data?.vision : "--"}
                </label>
              </div>
            </div>
            <div className="shine-card mb-5 md:mb-10">
              <h3 className="text-xl md:text-2xl text-[#363030] font-bold mb-4">
                <span className="font-serif">What are you</span>{" "}<span className="font-serif-italic">looking for?</span>
              </h3>
              <div className="flex items-center gap-4">
                <i className="w-10 aspect-square bg-[#F1EFE7] rounded-lg flex items-center justify-center">
                  <img src={data?.looking_for_icon} alt="" className="w-6" />
                </i>
                <label className="font-semibold text-lg md:text-xl font-serif">
                  {data?.looking_for_name ? data?.looking_for_name : "--"}
                </label>
              </div>
            </div>
            <div className="shine-card mb-5 md:mb-10">
              <h3 className="text-xl md:text-2xl text-[#363030] font-bold mb-4">
                <span className="font-serif">Your Ideal</span>{" "}<span className="font-serif-italic">Team Member</span>
              </h3>
              <div className="flex items-center gap-4">
                <i className="w-10 aspect-square bg-[#F1EFE7] rounded-lg flex items-center justify-center">
                  <img src={data?.team_member_icon} alt="" className="w-6" />
                </i>
                <label className="font-semibold text-lg md:text-xl font-serif">
                  {data?.team_member_name}
                </label>
              </div>
            </div>
            <div className="shine-card mb-5 md:mb-10">
              <h3 className="text-xl md:text-2xl text-[#363030] font-bold mb-4">
                <span className="font-serif">Your</span>{" "}<span className="font-serif-italic">Ideal Role</span>
              </h3>
              <div className="flex items-center gap-4">
                <i className="w-10 aspect-square bg-[#F1EFE7] rounded-lg flex items-center justify-center">
                  <img src={data?.ideal_role_icon} alt="" className="w-6" />
                </i>
                <label className="font-semibold text-lg md:text-xl font-serif">
                  {data?.ideal_role_name ? data?.ideal_role_name : "--"}
                </label>
              </div>
            </div>
            <div className="shine-card mb-5 md:mb-10">
              <h3 className="text-xl md:text-2xl text-[#363030] font-bold mb-4">
                <span className="font-serif-italic">Strengths</span>
              </h3>
              <div className="flex flex-wrap gap-2 md:gap-4">
                {data?.own_strength.map((appData, i) => (
                  <span
                    className="flex items-center gap-2 bg-[#F1EFE7] rounded-3xl py-2 px-4"
                    key={i}
                  >
                    <img src={appData.strength_icon} alt="" className="w-6" />{" "}
                    <label className="font-medium font-serif">
                      {appData.strength_name ? appData.strength_name : "--"}
                    </label>
                  </span>
                ))}
              </div>
            </div>
            <div className="shine-card mb-5 md:mb-10">
              <h3 className="text-xl md:text-2xl text-[#363030] font-bold mb-4">
                <span className="font-serif">Looking for</span>{" "}<span className="font-serif-italic">Strengths</span>
              </h3>
              <div className="flex flex-wrap gap-2 md:gap-4">
                {data?.looking_for_strengths.map((appData, i) => (
                  <span
                    className="flex items-center gap-2 bg-[#F1EFE7] rounded-3xl py-2 px-4"
                    key={i}
                  >
                    <img
                      src={appData.looking_for_strength_icon}
                      alt=""
                      className="w-6"
                    />
                    <label className="font-medium font-serif">
                      {appData.looking_for_strength_name}
                    </label>
                  </span>
                ))}
              </div>
            </div>
            <div className="shine-card">
              <h3 className="text-xl md:text-2xl text-[#363030] font-bold mb-4">
                <span className="font-serif-italic">Experience</span>
              </h3>
              {data?.experience.map((appData, i) => (
                <div className="flex items-start gap-4 mb-6" key={i}>
                  <i className="w-10 aspect-square bg-[#F1EFE7] rounded-lg flex items-center justify-center">
                    <img src={briefcaseIcon} alt="" className="w-6" />
                  </i>
                  <div className="flex-1">
                    <span className="text-[#363030] font-serif">
                      {appData.company_name}
                    </span>
                    <h4 className="py-1.5 text-lg font-bold leading-none font-serif-italic">
                      {appData.title}
                    </h4>
                    <span className="text-[#363030] font-serif">
                      {appData.start_date.concat(
                        " - ",
                        appData.in_current_job ? "Present" : appData.end_date
                      )}
                    </span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
        <ToastContainer />
      </div>
    );
  } else {
    return <div className="flex justify-center items-center h-screen">
      <p>{errorMessage}</p>
      <ToastContainer />
    </div>;
  }
}

export default Profile;
